import { AutenticacionService } from './autenticacion.service';
import { ErrorsService } from './tools/errors.service';
import { ValidatorService } from './tools/validator.service';
import { ConstantsService } from './constants.service';
import { Http, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
declare var $;

@Injectable()
export class MovimientosObraService {
  private apiURL: string;
  private service_url: string;

  constructor(private http: Http,
    private constantsServices: ConstantsService,
    private validatorService: ValidatorService,
    private errorService: ErrorsService,
    private authService: AutenticacionService) {
    this.apiURL = constantsServices.apiURL;
    this.service_url = this.apiURL + '/movimientos';
  }

  public getDefaultSchedule() {
    return {
      'idMovimientos': '',
      'idCuentas': '',
      'idConceptos': '',
      'idConceptosEgreso': '',
      'idObras': '',
      'idProveedores': '',
      'folio': '',
      'fechaMovimiento': '',
      'importe': '',
      'descripcion': '',
      'numero': '',
      'presupuesto': '',
      'tipoMovimiento': 1,
      'cfdi': '',
      'enviadoCfdi': '',
      'proyecciones': '',
      'proyeccionToMovimiento': '',
      'chequeCancelado': false,
      'chequeConciliado': false,
      'ingresoInterno': false,

      'chequeTransferencia': false,
      'cuentas': {},
      'conceptos': {
        'traspaso': 0
      },
      'conceptosEgreso': {
        'traspaso': 0
      },
      'obras': {},
      'proveedores': {}
    };
  }

  public createMovimientosObra(data) {
    //console.log("createMovimientosObra this.service_url: ",this.service_url);
    //console.log("createMovimientosObra data: ",data);
    return this.http.post(this.service_url, data, this.authService.getAuthHeaders());
  }

  public updateMovimientosObra(data, id) {
    //console.log("updateMovimientosObra this.service_url: ",this.service_url + '?id=' + id);
    //console.log("updateMovimientosObra data: ",data);
    return this.http.put(this.service_url + '?id=' + id, data, this.authService.getAuthHeaders());
  }

  public searchMovimientosObra(text, page = null) {
    if (page) {
      return this.http.get(this.service_url + '?paginate=true&search=' + text + '&page=' + page, this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '?paginate=true&search=' + text, this.authService.getAuthHeaders());
  }

  public searchMovimientosObraWithFilters(text, filters, page = null) {

    if (page) {
      return this.http.get(this.service_url + '?paginate=true&search=' + text + '&page=' + page + '&filter=' + this.filtersURL(filters), this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '?paginate=true&search=' + text + '&filter=' + this.filtersURL(filters), this.authService.getAuthHeaders());
  }

  public searchMovimientosObraWithFiltersNoPagination(text, filters) {

    let serviceUrl = this.service_url + '?search=' + text + '&filter=' + this.filtersURL(filters);

    //Agregar el filtro de tipoMovimiento
    if (filters.tipoMovimiento) {
      serviceUrl += `&tipoMovimiento=${filters.tipoMovimiento}`;
    }

    return this.http.get(serviceUrl, this.authService.getAuthHeaders());
  }

  public getTotales(filters) {
    let serviceUrl = this.service_url + '/totales?filter=' + this.filtersURL(filters);

    if (filters.tipoMovimiento) {
      serviceUrl += `&tipoMovimiento=${filters.tipoMovimiento}`;
    }

    return this.http.get(serviceUrl, this.authService.getAuthHeaders());
  }

  public getMovimientosObra(page = null) {
    console.log("La pagina es: " + page);
    if (page) {
      return this.http.get(this.service_url + '?paginate=true&page=' + page, this.authService.getAuthHeaders());
    }
    return this.http.get(this.service_url + '?paginate=true', this.authService.getAuthHeaders());
  }

  public deleteMovimientoObra(folio) {
    return this.http.delete(this.service_url + '?folio=' + folio, this.authService.getAuthHeaders());
  }

  public getMovimientosObraWithFilters(filters, page = null) {
    let serviceUrl = this.service_url + '?paginate=true' + '&filter=' + this.filtersURL(filters);

    if (page) {
      serviceUrl = this.service_url + '?paginate=true&page=' + page + '&filter=' + this.filtersURL(filters);
    }

    if (filters.tipoMovimiento) {
      serviceUrl += `&tipoMovimiento=${filters.tipoMovimiento}`;
    }
    var movimeintos = this.http.get(serviceUrl, this.authService.getAuthHeaders());
    console.log(movimeintos);
    return movimeintos;
  }

  public getMovimientosObraWithFiltersNoPagination(filters) {
    let serviceUrl = this.service_url + '?filter=' + this.filtersURL(filters);

    if (filters.tipoMovimiento) {
      serviceUrl += `&tipoMovimiento=${filters.tipoMovimiento}`;
    }

    return this.http.get(serviceUrl, this.authService.getAuthHeaders());
  }

  activeSecurityModule(password) {
    const data = { password: password }
    return this.http.post(this.service_url + '/key', data, this.authService.getAuthHeaders());
  }

  public getFechaActual() {
    return this.http.get(this.service_url + '/fecha', this.authService.getAuthHeaders());
  }

  public writePermission() {
    return this.authService.hasPermission(1, true);
  }

  public canExport() {
    return this.authService.canExport();
  }

  public canSecurity() {
    return this.authService.canSecurity();
  }

  public exportCSV(filters) {
    const options = this.authService.getAuthHeaders();
    options.responseType = ResponseContentType.Blob;

    let serviceUrl = this.service_url + '/exportar?filter=' + this.filtersURL(filters);

    if (filters.tipoMovimiento) {
      serviceUrl += `&tipoMovimiento=${filters.tipoMovimiento}`;
    }

    return this.http.get(serviceUrl, options)
      .map((response) => {
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.blob());
        const contentDispositionHeader = response.headers.get('content-disposition');
        const result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
        link.download = result.replace(/"/g, '');
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          link.remove();
        }, 200);
      });
  }

  filtersURL(filters) {
    let route_query = '';
    /* obra */
    route_query = (filters.obraFilter.idObras || '');
    route_query = route_query + '|';

    /* cuentas */
    filters.cuentasFilter.map(function (idCuentas, i, cuentas) {
      route_query = route_query + idCuentas;
      if (cuentas.length - 1 != i) {
        route_query = route_query + ',';
      }
    });
    route_query = route_query + '|';

    /* conceptos */
    filters.conceptosFilter.map(function (idConceptos, i, conceptos) {
      route_query = route_query + idConceptos;
      if (conceptos.length - 1 != i) {
        route_query = route_query + ',';
      }
    });
    route_query = route_query + '|';

    /* proveedores */
    filters.proveedoresFilter.map((proveedor, i, proveedores) => {
      if (proveedor['idProveedores'] !== undefined) {
        // 0- nos dice que se está enviando un proveedor individual
        route_query = route_query + '0-' + proveedor.idProveedores;
      } else if (proveedor['idInversionistas'] !== undefined) {
        // 1- nos dice que se está enviando un grupo de proveedor
        route_query = route_query + '1-' + proveedor.idInversionistas;
      }

      if (proveedores.length - 1 != i) {
        route_query = route_query + ',';
      }
    });
    route_query = route_query + '|';

    /* tipo proveedor */
    route_query = route_query + (filters.tipoProveedorFilter.idTipo_Proveedor || '');
    route_query = route_query + '|';

    /* fecha inicial */
    route_query = route_query + (filters.fechaInicial || '');
    route_query = route_query + '|';

    /* fecha final */
    route_query = route_query + (filters.fechaFinal || '');

    return route_query;
  }

  public validateMovimientosObra(data) {
    let error = [];

    // validacion de OBRA
    if ($.isEmptyObject(data['obras'])) {
      error['obras'] = this.errorService.required;
    }

    // validacion de CUENTA
    if ($.isEmptyObject(data['cuentas'])) {
      error['cuentas'] = this.errorService.required;
    }

    // validacion de FECHA INICIO
    const now = new Date().toISOString().slice(0, 10);
    if (!this.validatorService.required(data['fechaMovimiento']) || data['fechaMovimiento'] == '0000-00-00') {
      error['fechaMovimiento'] = this.errorService.required;
    } else if (!this.validatorService.date(data['fechaMovimiento'])) {
      error['fechaMovimiento'] = this.errorService.generic;
    } else if (!this.validatorService.dateBetween(data['fechaMovimiento'], '2012-01-01', now)) {
      error['fechaMovimiento'] = this.errorService.betweenDate;
    }

    // validacion de CONCEPTO
    if (!this.validatorService.required(data['conceptos'].idConceptos)) {
      error['conceptos'] = this.errorService.required;
    }

    // validacion de CONCEPTO EGRESO
    if (data['conceptosEgreso']) {
      if (
        !this.validatorService.required(data['conceptosEgreso'].idConceptos) &&
        data['ingresoInterno'] == true
      ) {
        error['conceptosEgreso'] = this.errorService.required;
      }
    }



    // validacion de DESCRIPCION
    if (this.validatorService.required(data['descripcion']) && !this.validatorService.max(data['descripcion'], 200)) {
      error['descripcion'] = this.errorService.max(200);
    }

    // validacion de IMPORTE
    if (!this.validatorService.required(data['importe'])) {
      error['importe'] = this.errorService.required;
    }

    // validacion de TRASPASO
    if (data['conceptos'].traspaso == 1) {

      // validacion de CUENTA DESTINO
      if ($.isEmptyObject(data['cuenta_destino'])) {
        error["cuenta_destino"] = this.errorService.required;
      }
      else if (data['cuenta_destino'].idCuentas == data['cuentas'].idCuentas) {
        error["cuenta_destino"] = 'La cuenta destino debe ser diferente a la cuenta origen.';
      }

    }

    // validacion de EGRESO Y Traspaso
    if (data['tipoMovimiento'] != 2) {


      // validacion de Numero cheque
      if (data['numero'] !== "")
        if (!this.validatorService.numeric(data['numero'])) {
          error['numero'] = this.errorService.numeric;
        } else if (!this.validatorService.max(data['numero'], 20)) {
          error["numero"] = this.errorService.max(20);
        }

      // validacion de CFDI
      if (this.validatorService.required(data['cfdi']) && !this.validatorService.max(data['cfdi'], 200)) {
        error["cfdi"] = this.errorService.max(200);
      }

    }
    //validacion ingreso y egreso
    if (data['conceptos'].traspaso != 1) {
      // validacion de PROVEEDORES
      if ($.isEmptyObject(data['proveedores'])) {
        error['proveedores'] = this.errorService.required;
      }
    }

    return error;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/movimientos-obra.service.ts